<template>
  <div
    style="position: relative"
    :class="[
      'cabinet_sidebar transition-width duration-300',
      { 'w-20': isCollapsed, 'w-68': !isCollapsed && !isMobile },
    ]"
    @transitionend="handleTransitionEnd"
  >

    <div class="sidebar-toggle"
         v-if="!isMobile"
         @click="toggleSidebar"
         :class="[
            'pointer mr-auto',
            {
              'rotate-90': isCollapsed,
              'grey-4-color': !isCollapsed,
              'green-4-color': isCollapsed,
            },
          ]"
    >

      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="#666666" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>
    </div>

<!--    <router-link :to="{ name: 'home.index' }">-->
        <div
          v-show="isCollapsed"
          style="margin-left: 22px;"
          class="logo-content cabinet_logo"
          key="short"
        >
          <img alt="" class="w-10 h-10 outline-none focus:outline-none active:outline-none" src="/img/logo-short.svg" @click="navigateToHome" />
        </div>
        <div
          v-show="!isCollapsed"
          class="logo-content cabinet_logo"
          key="full"
        >
          <img class="h-10 w-46 outline-none focus:outline-none active:outline-none" src="/image/header-logo.svg" alt="" @click="navigateToHome" />
          <InlineSvg
            class="beta-badge"
            style="width: 40px"
            src="/img/beta.svg"
          ></InlineSvg>
        </div>
<!--    </router-link>-->


    <ul class="cabinet_sidebar_menu">
      <li v-for="(route, index) in routes"
          :key="route.name"
          :style="{ '--index': index }"
          class="relative group">
        <router-link
          :class="[
    'text-base-small grey-4-color flex items-center',
    {
      active: isActiveRoute(route.name),
      'pl-4': !isCollapsed,
      disabled: route.isDisabled,
      'pl-0': isCollapsed,
    },
  ]"
          :to="{ name: route.name }"
        >
          <BaseIcon :icon="route.icon" :active="isActiveRoute(route.name)" />
          <span
            v-show="!isCollapsed"
            class="menu-text"
          >
    {{ $t(route.label) }}
  </span>
          <span
            v-show="isCollapsed && !route.isDisabled"
            class="tooltip"
          >
    {{ $t(route.label) }}
  </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "SidebarMain",
  data() {
    return {
      activeRoute: this.$route.name,
      isCollapsed: false,
      routes: [
        {
          name: "contract.cabinet.index",
          icon: "info-icon",
          label: "general_information"
        },
        {
          name: "contract.cabinet.balance",
          icon: "balance-icon",
          label: "balances",
          isDisabled: false
        },
        {
          name: "contract.cabinet.site.index",
          icon: "site-icon",
          label: "my_sites",
          isDisabled: false
        },
        {
          name: "contract.cabinet.storage.index",
          icon: "cloud-icon",
          label: "file_storage",
          isDisabled: false
        },
        {
          name: "contract.cabinet.storageManager.index",
          icon: "cloud-manager-icon",
          label: "storage_manager",
          isDisabled: false
        },
        {
          name: "contract.cabinet.database.index",
          icon: "database-icon",
          label: "databases",
          isDisabled: false
        },
        {
          name: "contract.cabinet.cache.index",
          icon: "cache-icon",
          label: "cache",
          isDisabled: true
        },
        {
          name: "contract.cabinet.domain.index",
          icon: "domain-icon",
          label: "domains",
          isDisabled: false
        },
        {
          name: "contract.cabinet.certificate.index",
          icon: "certificate-icon",
          label: "certificates",
          isDisabled: false
        },
        {
          name: "contract.cabinet.processors.index",
          icon: "processors-icon",
          label: "processors",
          isDisabled: true
        },
        {
          name: "contract.cabinet.crons.index",
          icon: "cron-icon",
          label: "cron_of_task",
          isDisabled: false
        },
        {
          name: "contract.cabinet.customers.index",
          icon: "users-icon",
          label: "users"
        },
        {
          name: "contract.cabinet.backup.storage.plan.index",
          icon: "reserved-icon",
          label: "backup_copies",
          isDisabled: false
        },
        {
          name: "contract.cabinet.logs.index",
          icon: "logs-icon",
          label: "logs",
          isDisabled: true
        },
        {
          name: "contract.cabinet.load.index",
          icon: "server-icon",
          label: "web_server_load",
          isDisabled: false

        },
        {
          name: "contract.cabinet.history.index",
          icon: "invitation-icon",
          label: "history"
        }
      ],
      isMobile: window.innerWidth < 992,
      isTransitioning: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    isActiveRoute(routeName) {
      return this.activeRoute.indexOf(routeName) === 0;
    },
    setActiveContract(contractId) {
      return this.$store.dispatch("contract/setActiveContract", contractId);
    },
    handleResize() {
      this.isMobile = window.innerWidth < 992;
    },
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleTransitionEnd() {
      this.isTransitioning = false;
    },
    navigateToHome() {
      this.$router.push({ name: 'home.index' });
    }
  },
  watch: {
    handleResize() {
      this.isMobile = window.innerWidth < 992;
      if (this.isMobile) {
        this.isCollapsed = false;
      }
    },
    isCollapsed() {
      this.isTransitioning = true;
    },
    "$route.name": {
      handler: function(name) {
        this.activeRoute = name;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.sidebar-toggle {
  position: absolute;
  right: -12px;
  top: 30px;
  width: 24px;
  height: 24px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;
}

.rotate-90 {
  transform: rotate(-180deg);
}

.logo-wrapper {
  height: 40px;
  margin-bottom: 1.75rem;
  display: flex;
  align-items: center;
}

.logo-content {
  width: 100%;
  display: flex;
  align-items: center;
  opacity: 0;
  transform: translateX(-20px);
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.logo-content img {
  cursor: pointer;
}



.cabinet_sidebar_menu span {
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cabinet_sidebar:not(.w-20) .cabinet_sidebar_menu span {
  opacity: 1;
  transform: translateX(0);
}

.menu-text {
  margin-left: 0.75rem;
  white-space: nowrap;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateX(0);
}

.w-20 .menu-text {
  opacity: 0;
  transform: translateX(-10px);
}

.tooltip {
  position: absolute;
  left: 100%;
  margin-left: 0.5rem;
  padding: 0.5rem;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  z-index: 1000;
}

.group:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  pointer-events: auto;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.cabinet_sidebar_menu li {
  transition-delay: calc(0.05s * var(--index, 0));
}

.beta-badge {
  position: absolute;
  top: -28px;
  right: 105px;
  transform-origin: center;
  z-index: -5;
}
</style>
